<template>
  <div>
    <table class="table table-bordered table-striped table-hover">
      <thead class="thead-light">
      <tr>
        <th>SUCURSAL</th>
        <th>PERIODO</th>
        <th>VENTA AÑO ANTERIOR {{datos[0].anio_anterior}}</th>
        <th>VENTA AÑO ACTUAL {{datos[0].anio}}</th>
        <th>FACTOR</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="item in datos">
        <td>{{sucursal(item.sucursal_id).nombre | upper}}</td>
        <td>{{item.anio_anterior}}-{{item.anio}}</td>
        <td>{{item.venta_anio_anterior | currency}}</td>
        <td>{{item.venta_actual | currency}}</td>
        <td>{{item.factor_presupuesto}} %</td>
        <td><i class="fa fa-eye" title="Ver Detalle Periodo" @click="sendToCierrePeriodo(item)"></i></td>
      </tr>
      <tr v-if="datos.length >= 1" class="font-weight-bold">
        <td></td>
        <td align="right">Totales:</td>
        <td>{{sumarArray("venta_anio_anterior") | currency}}</td>
        <td>{{sumarArray("venta_actual") | currency}}</td>
        <td></td>
        <td><i class="fa fa-eye" title="Ver Consolidado" @click="modalOpen"></i></td>
      </tr>
      </tbody>
    </table>
    <modal-consolidado-sucursal ref="modalConsolidadoSucursal"/>
    <donut-component v-if="datos.length >= 1" :datos="datos"/>
  </div>
</template>

<script>
  import {mapGetters} from "vuex"
  import ventasAnual from "../Pages/ventasAnual";
  import ModalConsolidadoSucursal from "./modalConsolidadoSucursal";
  import VuesticChart from "../../../vuestic-theme/vuestic-components/vuestic-chart/VuesticChart";
  import DonutComponent from "./donutComponent";

  export default {
    name: "tablaPeriodoConsolidado",
    components: {DonutComponent, VuesticChart, ModalConsolidadoSucursal},
    props: ["datos"],
    computed: {
      ...mapGetters({
        sucursal: "sucursal"
      }),

    },
    methods: {
      modalOpen() {
        this.$refs.modalConsolidadoSucursal.openModal(this.datos)
      },
      sumarArray(key) {
        return this.datos.reduce((accumulate, actual) => accumulate += actual[key], 0)
      },
      sendToCierrePeriodo(item) {
        this.$router.push({
          name: "ventasAnual",
          params: {
            data: item
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>
